/**
 * @generated SignedSource<<8f3faabd42208f519264de7b1b90607e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LockedEventViewer$data = {
  readonly repository: {
    readonly owner: {
      readonly " $fragmentSpreads": FragmentRefs<"EventActor">;
    };
    readonly viewerCanPush: boolean;
  };
  readonly " $fragmentType": "LockedEventViewer";
};
export type LockedEventViewer$key = {
  readonly " $data"?: LockedEventViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LockedEventViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LockedEventViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanPush",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventActor"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "ce39e839d4b9133185774a9336e36b85";

export default node;
